"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Request {
    constructor() {
        this.type = 'common-fission';
        const { request } = require('@futuweb/fego-render').common;
        this.commonApi = request.bindCommonApi(this.type);
    }
    async getOrGenInviteCode(params) {
        const res = await this.commonApi.post('getOrGenInviteCode', Object.assign({}, params));
        return res;
    }
}
exports.default = new Request();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInJlcXVlc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxNQUFNLE9BQU87SUFNVDtRQUxBLFNBQUksR0FBRyxnQkFBZ0IsQ0FBQztRQU1wQixNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUMsTUFBTSxDQUFDO1FBQzNELElBQUksQ0FBQyxTQUFTLEdBQUcsT0FBTyxDQUFDLGFBQWEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7SUFDdEQsQ0FBQztJQUVELEtBQUssQ0FBQyxrQkFBa0IsQ0FBQyxNQUE2QjtRQUNsRCxNQUFNLEdBQUcsR0FBRyxNQUFNLElBQUksQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLG9CQUFvQixvQkFBTyxNQUFNLEVBQUcsQ0FBQztRQUMzRSxPQUFPLEdBQTRCLENBQUM7SUFDeEMsQ0FBQztDQUNKO0FBRUQsa0JBQWUsSUFBSSxPQUFPLEVBQUUsQ0FBQyJ9